<template>
  <quill-editor
    v-model="contentEditing"
    no-resize
    rows="4"
    class="p-0 m-0"
    :options="pjEditorOption"
    style="border: none; width: 100%"
    ref="quillEditor"
  />
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import ResizeModule from "@ssumo/quill-resize-module";
Quill.register('modules/resize', ResizeModule)
import VueMq from "vue-mq";
Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sp: 959,
    pc: 960,
  },
  defaultBreakpoint: "pc", // customize this for SSR
});
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

export default {
  name: "contentEditor",
  data: () => ({
    loading: true,
    contentEditing: "",
    pjEditorOption: {
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'font': [] }],
          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          ["bold", "italic", "underline", "strike"], // toggled buttons
          //['blockquote', 'code-block'],
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ align: [] }],
          ["link"],
          //['clean']
          ["image", "video"], // remove formatting button
        ],
        resize: {
          locale: {
            altTip: "altキーを押しながらドラッグすると比率を維持して拡大縮小できます",
            floatLeft: "左寄せ",
            floatRight: "右寄せ",
            center: "中央寄せ",
            restore: "元に戻す",
          }
        }
      },
      placeholder: "ここに入力してください",
    },
  }),
  props: ["defaultValue"],
  created() {
    if (this.defaultValue) this.contentEditing = this.defaultValue;
    window.addEventListener("beforeunload", this.confirmSave);
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.confirmSave);
  },
  components: {
    quillEditor,
  },
  computed: {
    isSp() {
      return this.$mq === "sp";
    },
    isAdmin() {
      return !this.isSp && (this.$store.state.isAdmin||(this.aboutLid&&this.aboutLid.lidAdmin&&this.aboutLid.lidAdmin.includes(this.$store.state.auth?.user?.uid || '')))
    },
    lid() {
      return this.$store.state.lid;
    },
    alid() {
      return this.$store.state.alid;
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
  },
  methods: {
    confirmSave(event) {
      if (this.contentEditing.length > 0) {
        event.returnValue = "このページから移動しますか？";
      }
    },
    submitContent: async function (fullPath) {
      console.log("submitContent", fullPath);
      try {
        const ref = firebase.storage().ref(fullPath);
        await ref.putString(this.contentEditing).then(()=>{
          this.contentEditing = ""
          this.$emit("submitContentCompleted")
        })
      } catch (error) {
        alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。")
        console.error("Error adding content for project:", error);
      }
    },
  },
};
</script>
<style scoped>
.cloud {
  color: #707070;
}
.folded {
  position: relative;
  overflow: hidden;
  height: 55vh;
}
.folded::before {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  content: "";
  height: 50px;
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 50%,
    #fff 100%
  );
  background: linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 50%,
    #fff 100%
  );
}

.qimg > div > p > img {
  max-width: 100% !important;
  height: auto !important;
}
.qimg > div > h2 > img {
  max-width: 100% !important;
  height: auto !important;
}
.qimg >>> img {
  max-width: 100% !important;
  height: auto !important;
}
</style>
